import { render } from "./NervGauge.vue?vue&type=template&id=ad36e9f4&scoped=true&ts=true"
import script from "./NervGauge.vue?vue&type=script&lang=ts"
export * from "./NervGauge.vue?vue&type=script&lang=ts"

import "./NervGauge.vue?vue&type=style&index=0&id=ad36e9f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad36e9f4"]])

export default __exports__